var merge = require('lodash/merge')

const mutations = {
  SET_APPLICATION(state, application) {
    state.application = application
  },
  UPDATE_APPLICATION(state, application) {
    const mergedData = merge(JSON.parse(JSON.stringify(state.application)),application)
    //- Need special handling as merge, well merges... and don't replace
    if (application.professionOrientations) {
      mergedData.professionOrientations = application.professionOrientations
    }
    state.application = mergedData
  },
  SET_CURRENTSTEP(state, currentStep) {
    state.currentStep = currentStep
  },
  SET_EDUCATION(state, bool) {
    state.haveEducation = bool;
  }
}
export default mutations
